import React, { useEffect } from 'react';
import styles from './ColumnSection.module.css';
import { Column, deleteColumnById } from 'features/document/documentSlice';
import { useAppDispatch } from 'app/hooks';
import ElementSection from '../ElementSection/ElementSection';

interface Props {
  column: Column;
  pageId: string;
  index: number;
  rowId: string;
}

const ColumnSection: React.FC<Props> = ({ column, pageId, rowId }) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (column.elements.length === 0) {
      dispatch(deleteColumnById({ pageId, rowId, columnId: column.id }));
    }
  }, [column, pageId, dispatch, rowId]);

  return (
    <div className={styles.container}>
      {column.elements.map((element, index) => {
        return (
          <div className={styles.elementContainer} key={element.id}>
            <ElementSection rowId={rowId} currentElement={element} pageId={pageId} index={index} columnId={column.id} />
          </div>
        );
      })}
    </div>
  );
};

export default ColumnSection;
